module.exports = __webpack_public_path__ + "img/10 Aniamtion 3-squashed.39460a95.jpg";